import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "counter__items" }
const _hoisted_3 = ["data-qa"]
const _hoisted_4 = ["data-qa"]
const _hoisted_5 = ["data-qa"]
const _hoisted_6 = ["data-qa"]
const _hoisted_7 = ["data-qa"]
const _hoisted_8 = ["data-qa"]
const _hoisted_9 = ["data-qa"]
const _hoisted_10 = ["data-qa"]

import { CounterPanel } from '@/types'

interface Props {
  title: string
  subtitle?: string
  info: CounterPanel
  type?: string
  showIndicator?: boolean
  frvType: 'main' | 'rv'
}


export default /*@__PURE__*/_defineComponent({
  __name: 'VitaCounter',
  props: {
    title: {},
    subtitle: {},
    info: {},
    type: {},
    showIndicator: { type: Boolean, default: true },
    frvType: {}
  },
  setup(__props: any) {

const props = __props

const calculate = (col: number): number => {
  if (props.info.dedicated) {
    const oneProc = props.info.dedicated / 100
    return +(col / oneProc).toFixed(1)
  } else {
    return 0
  }
}

const formatNumber = (planned: number, actual: number) => {
  let str = (planned + actual).toFixed(2)
  if (str.includes('.')) {
    while (str.endsWith('0')) {
      str = str.slice(0, -1)
    }
    if (str.endsWith('.')) {
      str = str.slice(0, -1)
    }
  }

  return str
}

const colorIndicator = (col: number): string => {
  if (!props.info.dedicated) return ''

  if (col < props.info.dedicated) {
    return 'orange'
  } else if (col === props.info.dedicated && col !== 0) {
    return 'green'
  } else if (col > props.info.dedicated) {
    return 'red'
  } else {
    return 'grey'
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["counter", __props.type])
  }, [
    _createElementVNode("div", null, [
      _createElementVNode("h2", null, _toDisplayString(__props.title), 1),
      (__props.subtitle)
        ? (_openBlock(), _createElementBlock("h3", _hoisted_1, _toDisplayString(__props.subtitle), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "counter__item",
        "data-qa": `frv-${__props.frvType}-counter-actual`
      }, [
        _cache[0] || (_cache[0] = _createElementVNode("h4", null, "Фактический", -1)),
        _createElementVNode("p", null, [
          _createElementVNode("span", {
            class: _normalizeClass([colorIndicator(__props.info.actual), { indicator: __props.showIndicator }])
          }, null, 2),
          _createElementVNode("b", {
            "data-qa": `frv-${__props.frvType}-counter-actual-value`
          }, _toDisplayString(__props.info.actual) + " ч", 9, _hoisted_4),
          (__props.showIndicator)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: "counter__proc",
                "data-qa": `frv-${__props.frvType}-counter-actual-pct`
              }, _toDisplayString(calculate(__props.info.actual)) + "%", 9, _hoisted_5))
            : _createCommentVNode("", true)
        ])
      ], 8, _hoisted_3),
      _createElementVNode("div", {
        class: "counter__item",
        "data-qa": `frv-${__props.frvType}-counter-planned`
      }, [
        _cache[1] || (_cache[1] = _createElementVNode("h4", null, "Запланированный", -1)),
        _createElementVNode("p", null, [
          _createElementVNode("span", {
            class: _normalizeClass([colorIndicator(__props.info.planned + __props.info.new), { indicator: __props.showIndicator }])
          }, null, 2),
          _createElementVNode("b", {
            "data-qa": `frv-${__props.frvType}-counter-planned-value`
          }, _toDisplayString(formatNumber(__props.info.planned, __props.info.new)) + " ч", 9, _hoisted_7),
          (__props.showIndicator)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: "counter__proc",
                "data-qa": `frv-${__props.frvType}-counter-planned-pct`
              }, _toDisplayString(calculate(__props.info.planned + __props.info.new)) + "%", 9, _hoisted_8))
            : _createCommentVNode("", true)
        ])
      ], 8, _hoisted_6),
      (__props.info.dedicated || __props.info.dedicated?.toString() === '0')
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "counter__item",
            "data-qa": `frv-${__props.frvType}-counter-dedicated`
          }, [
            _cache[2] || (_cache[2] = _createElementVNode("h4", null, "Выделенный", -1)),
            _createElementVNode("p", null, [
              _createElementVNode("b", {
                "data-qa": `frv-${__props.frvType}-counter-dedicated-value`
              }, _toDisplayString(__props.info.dedicated) + " ч", 9, _hoisted_10)
            ])
          ], 8, _hoisted_9))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})